import { useSelector } from "react-redux";
import { darkTheme, lightTheme } from "./Theme";

const useThemeRender = (property) => {
  const isDarkTheme = useSelector((state) => state.theme); 
  return isDarkTheme ? darkTheme[property] : lightTheme[property];
};

export default useThemeRender;
